module.exports = __webpack_public_path__ + "img/crypto-seed-phrase-storage_B096HZNWQY.e96431eb.jpg";